import { Dimensions } from "react-native";

const { width } = Dimensions.get("window");
const MaxWidth = 600;
const ScreenWidth = width > MaxWidth ? MaxWidth : width;

export { MaxWidth, ScreenWidth };
